<template>
  <div>
    <!--搜索部分-->
    <el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="反馈类型">
        <el-select v-model="enquiryForm.feedback_type" placeholder="请选择反馈类型" clearable filterable>
          <el-option
              v-for="item in feedback_type_options"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理状态">
        <el-select v-model="enquiryForm.process_status" placeholder="请选择处理状态" clearable filterable>
          <el-option
              v-for="item in process_status_options"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <div style="margin-bottom: 10px">
      <!-- 按钮部分 -->
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询
      </el-button>
      <el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
    </div>
    <!--表格部分-->
    <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
        v-loading="loading"
        border
        id="tableDataId"
        size="mini"
    >
      <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="ID"
          sortable>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="real_name"
          label="反馈人">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="mobile_phone"
          label="手机号码">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="feedback_type"
          label="反馈类型">
        <template slot-scope="scope">
          {{ scope.row.feedback_type.text }}
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="feedback_content"
          label="反馈内容">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="process_status"
          label="处理状态">
        <template slot-scope="scope">
          {{ scope.row.process_status.text }}
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="process_time"
          label="处理时间">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="process_remark"
          label="备注">
      </el-table-column>
      <el-table-column label="操作" align="center" header-align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.$index, scope.row)">处理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[20,50,100,200,500,1000]"
        :page-size="page_size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="text-align: right"
    ></el-pagination>

    <!-- 处理对话框 -->
    <el-dialog title="处理" :visible.sync="handleFormVisible">
      <el-form :model="handleForm" label-width="100px">
        <el-form-item label="处理状态" style="width: 400px">
          <el-radio-group v-model="handleForm.process_status" style="width: 400px">
            <el-radio
                v-for="item in process_status_options"
                :label="item.value"
            >{{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" style="width: 400px">
          <el-input
              style="width: 400px"
              type="textarea"
              v-model="handleForm.process_remark"
              :autosize="{ minRows: 2, maxRows: 8}"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHandleForm(handleForm)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "feedback",
  data() {
    return {
      // 主页面部分
      loading: true, //列表loadding
      page_size: 20, //条数
      total: 0,  //总数
      handleFormVisible: false, //处理对话框显隐
      // 表格数据
      tableData: [],
      // 查询表单
      enquiryForm: {
        feedback_type: '', //反馈类型
        process_status: '', //处理状态
        page: 1,
        page_size: 20
      },
      // 处理表单
      handleForm: {
        id: '',
        process_status: '',
        process_remark: ''
      },
      // 意见类型
      feedback_type_options: [{
        label: 'BUG',
        value: '10'
      }, {
        label: '建议',
        value: '20'
      }],
      // 处理状态
      process_status_options: [{
        label: '未处理',
        value: '00'
      }, {
        label: '已处理',
        value: '10'
      }, {
        label: '处理中',
        value: '20'
      }],
    }
  },
  created() {
    this.getData(this.enquiryForm)
  },
  methods: {
    // 主页面部分
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.feedback_type = ''; //反馈类型
      searchForm.process_status = ''; //处理状态
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/user/feedbackList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    // 打开处理对话框
    handleEdit(index, params) {
      //alert(JSON.stringify(params))
      this.handleFormVisible = true;
      this.handleForm.id = params.id;
      this.handleForm.process_status = params.process_status.value;
      this.handleForm.process_remark = params.process_remark;
    },
    // 隐藏处理表单
    submitHandleForm(params) {
      this.handleFormVisible = false;
      this.$api.post("/api/user/feedbackUpdate?page=" + this.enquiryForm.page, params, res => {
        if (res.status == 200) {
          this.$message.success(res.msg);
          // 刷新列表
          this.getData(this.enquiryForm);
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>
